import { trackAudioLevel } from '../audio-level'

const template = document.createElement('template')
template.innerHTML = `
  <style>
    video {
      display: block;
      width: 100%;
      aspect-ratio: 4 / 3;
      object-fit: cover;
      border-radius: var(--radius-md);
      background: var(--color-media);
      /* Show ourselves as in a mirror. Only the preview flips; others see the camera as is. */
      transform: scaleX(-1);
      /* Speaking indicator. An outline grows outward without shifting the layout. */
      --speaking-width: calc(var(--speaking-width-min) + var(--audio-level, 0) * (var(--speaking-width-max) - var(--speaking-width-min)));
      outline: var(--speaking-width) solid var(--color-accent);
    }
  </style>
  <video playsinline muted></video>
`

/** Opens the camera and mic, previews the video, and fires `capture-ready` with the stream. */
export class MeatCapture extends HTMLElement {
  root: ShadowRoot
  mirror: HTMLVideoElement
  stream?: MediaStream

  constructor() {
    super()
    this.root = this.attachShadow({ mode: 'open' })
    this.root.append(template.content.cloneNode(true))
    this.mirror = this.root.querySelector('video')!

    this.initMedia()
  }

  async initMedia() {
    const constraints = {
      video: true,
      audio: true
    }

    try {
      this.stream = await navigator.mediaDevices.getUserMedia(constraints)
      this.renderMirror(this.stream)
      trackAudioLevel(this.stream, this.mirror)
      this.dispatchEvent(new CustomEvent('capture-ready', { detail: this.stream, bubbles: true }))
    } catch (err) {
      console.error('Error opening webcam', err)
    }
  }

  renderMirror(stream: MediaStream) {
    // Preview the video track only — attaching the audio track would play the mic
    // back through the speakers and feed it straight into the capture.
    this.mirror.srcObject = new MediaStream(stream.getVideoTracks())

    this.mirror.onloadedmetadata = () => {
      console.log('starting video preview')
      this.mirror.play()
    }
  }
}

customElements.define('meat-capture', MeatCapture)

declare global {
  interface HTMLElementTagNameMap {
    'meat-capture': MeatCapture
  }
  interface HTMLElementEventMap {
    'capture-ready': CustomEvent<MediaStream>
  }
}
